<nav aria-label="breadcrumb">
	<ol class="breadcrumb mb-0 pl-0">
		<li class="breadcrumb-item"><a [href]="'/calendario-inicio'">Calendarización</a></li>
		<li class="breadcrumb-item active" aria-current="page"><a><strong>{{ formEdit ? 'Editar' : 'Crear'}}</strong></a></li>
	</ol>
</nav>
<div class="row">
	<button (click)="navToCalendarizacion()" class="boton_volver"  data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER"><i class="bi bi-chevron-left mr-2"></i>Volver</button>
	<h1 class="centrar_contenido offset-3">{{ formEdit ? 'Editar' : 'Crear'}} mantenedor<br>calendarización de procesos</h1>
</div>


<!-- DETALLE CONFIGURACIÓN -->
<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Detalle configuración:</h6>
</div>

<div class="alert alert-danger tipografía_alertas mt-4 mb-0 animate__fadeIn" role="alert" *ngIf="errorMsg !== ''">
	<i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ errorMsg }}
	<button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
		<span aria-hidden="true" class="alert-danger">&times;</span>
	</button>
</div>

<form class="form" [formGroup]="parametrosForm">
	<div class="row mt-5 align-items-end">
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
			<select id="select_anyo" class="form-control select_criterios" formControlName="anyo" [(ngModel)]="filtroAnyo" (ngModelChange)="resetearValidacion();cargarFiltros('anyo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let anyo of listaAnyo" [value]="anyo">{{anyo}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErrores['anyo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
			<select id="select_periodo" class="form-control select_criterios" formControlName="periodo" [(ngModel)]="filtroPeriodo" (ngModelChange)="resetearValidacion();cargarFiltros('periodo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let periodo of listaPeriodo" [value]="periodo.periodoAcademicoId">{{periodo.periodoDescripcion}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErrores['periodo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-3">
			<label class="titulo_criterios" for="select_proceso">Proceso</label>
			<select id="select_proceso" class="form-control select_criterios" formControlName="proceso" [(ngModel)]="filtroProceso" (ngModelChange)="resetearValidacion();cargarFiltros('proceso')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['proceso'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let proceso of listaProceso" [value]="proceso.procesoId">{{proceso.codigoProceso}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['proceso']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErrores['proceso']">Campo requerido</div>
			</div>
		</div>
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Fecha inicio</label>
			<input type="date" (change)="resetearValidacion()" formControlName="fechaInicio" [(ngModel)]="fechaInicio" class="form-control select_criterios" placeholder="11/11/2023" aria-describedby="basic-addon2" [ngClass]="{ 'is-invalid': submitted && tieneErrores['fechaInicio'] }">
			<div *ngIf="submitted && tieneErrores['fechaInicio']" class="invalid-feedback">
				<div *ngIf="tieneErrores['fechaInicio']" class="position-absolute">Campo requerido</div>
			</div>
		</div>
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Fecha término</label>
			<input type="date" (change)="resetearValidacion()" formControlName="fechaFin" [(ngModel)]="fechaFin" class="form-control select_criterios" placeholder="11/11/2023" aria-describedby="basic-addon2" [ngClass]="{ 'is-invalid': submitted && tieneErrores['fechaFin'] }">
			<div *ngIf="submitted && tieneErrores['fechaFin']" class="invalid-feedback">
				<div *ngIf="tieneErrores['fechaFin']" class="position-absolute">Campo requerido</div>
			</div>
		</div>
	</div>
	
	<div class="row mt-4">
		<div class="col-11">
			<div class="form-group">
				<label class="titulo_criterios" for="descripcion">Descripción</label>
				<textarea class="form-control select_criterios" id="descripcion" placeholder="Máx. 300 caracteres" maxlength="300" rows="5" (change)="resetearValidacion()" formControlName="descripcion" [(ngModel)]="descripcion" class="form-control select_criterios" [ngClass]="{ 'is-invalid': submitted && tieneErrores['descripcion'] }"></textarea>
				<div *ngIf="submitted && tieneErrores['descripcion']" class="invalid-feedback position-absolute">
					<div *ngIf="tieneErrores['descripcion']">Campo requerido</div>
				</div>
			</div>
		</div>
	</div>
	<!-- FIN DETALLE CONFIGURACIÓN -->
	
	<div class="mb-5 mt-5 pb-4">
		<button (click)="navToCalendarizacion()" class="boton-secundario offset-4" data-toggle="tooltip" data-placement="top" title="CANCELAR" alt="CANCELAR">cancelar</button>
		<button (click)="crear()" class="boton-primario tamanio_minimo ml-3" data-toggle="tooltip" data-placement="top" title="CREAR" alt="CREAR" [ngClass]="{ 'btn-edit': formEdit }">{{ formEdit ? 'Guardar cambios' : 'Crear'}}</button>
	</div>
</form>